
export function emailPattern() : string {
   //Changed regex quantifier upto 5 due to task 115161
   return "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}$";
}
